import Dialog from '../Dialog';
import { DialogContent, Typography, Stack, Button } from '@mui/material';
import DialogTitle from '../DialogTitle';
import useResponsive from '../../hooks/useResponsive';
import Scrollbar from 'src/components/Scrollbar';
import useWindowDimensions from 'src/hooks/useWindowDimensions';
import useLocales from 'src/hooks/useLocales';

interface Props {
    open: boolean;
    onClose: () => void;
}

export default function CareCircleTerms({ open, onClose }: Props) {
    const isDesktop = useResponsive('up', 'lg');
    const { height } = useWindowDimensions()
    const { translate } = useLocales()

    const TERMS = [
        {
            title: translate('components.careCircle.terms.item1Title'),
            desc: translate('components.careCircle.terms.item1Desc')
        },
        {
            title: translate('components.careCircle.terms.item2Title'),
            desc: translate('components.careCircle.terms.item2Desc')
        },
        {
            title: translate('components.careCircle.terms.item3Title'),
            desc: translate('components.careCircle.terms.item3Desc')
        },
        {
            title: translate('components.careCircle.terms.item4Title'),
            desc: translate('components.careCircle.terms.item4Desc')
        },
        {
            title: translate('components.careCircle.terms.item5Title'),
            desc: translate('components.careCircle.terms.item5Desc')
        },
        {
            title: translate('components.careCircle.terms.item6Title'),
            desc: translate('components.careCircle.terms.item6Desc')
        },
        {
            title: translate('components.careCircle.terms.item7Title'),
            desc: translate('components.careCircle.terms.item7Desc')
        },
        {
            title: translate('components.careCircle.terms.item8Title'),
            desc: translate('components.careCircle.terms.item8Desc')
        },
        {
            title: translate('components.careCircle.terms.item9Title'),
            desc: translate('components.careCircle.terms.item9Desc')
        },
        {
            title: translate('components.careCircle.terms.item10Title'),
            desc: translate('components.careCircle.terms.item10Desc')
        },
    ]

    return (
        <Dialog
            onClose={onClose}
            aria-labelledby={`registration-dialog`}
            open={open}
            maxWidth={isDesktop ? 'smd' : 'xs'}
            fullWidth
        >
            <DialogTitle onClose={onClose}>
                <Stack alignItems={"flex-start"}>
                <Typography variant="h6">
                    {translate('components.careCircle.terms.title')}
                </Typography>
                <Typography variant="body1" color={"text.secondary"}>
                    {translate('components.careCircle.terms.effective')}
                </Typography>
                </Stack>
            </DialogTitle>
            
            <DialogContent sx={{ p: 0 }}>
                <Scrollbar sx={{height: height * 0.65, maxHeight: "80%", my: 2}}>
                {
                    TERMS.map(term => (
                        <Stack key={term.title} sx={{pb: 4}}>
                            <Typography variant="subtitle1">{term.title}</Typography>
                            <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>{term.desc}</Typography>
                        </Stack>
                    ))
                }
                </Scrollbar>
                <Stack alignItems={"center"}>
                    <Button variant="outlined" onClick={onClose}>{translate('components.careCircle.terms.dismiss')}</Button>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}


